import { render } from "./AddTaskPopUp.vue?vue&type=template&id=06d76538&scoped=true"
import script from "./AddTaskPopUp.vue?vue&type=script&lang=js"
export * from "./AddTaskPopUp.vue?vue&type=script&lang=js"

import "./AddTaskPopUp.vue?vue&type=style&index=0&id=06d76538&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d76538"]])

export default __exports__